export default [
  {
    name: 'Январь',
    viewValue: '01',
    value: 0,
  },
  {
    name: 'Февраль',
    viewValue: '02',
    value: 1,
  },
  {
    name: 'Март',
    viewValue: '03',
    value: 2,
  },
  {
    name: 'Апрель',
    viewValue: '04',
    value: 3,
  },
  {
    name: 'Май',
    viewValue: '05',
    value: 4,
  },
  {
    name: 'Июнь',
    viewValue: '06',
    value: 5,
  },
  {
    name: 'Июль',
    viewValue: '07',
    value: 6,
  },
  {
    name: 'Август',
    viewValue: '08',
    value: 7,
  },
  {
    name: 'Сентябрь',
    viewValue: '09',
    value: 8,
  },
  {
    name: 'Октябрь',
    viewValue: '10',
    value: 9,
  },
  {
    name: 'Ноябрь',
    viewValue: '11',
    value: 10,
  },
  {
    name: 'Декабрь',
    viewValue: '12',
    value: 11,
  },
];
